import React from 'react'
import { find, sortBy, each, isArray, filter, cloneDeep, concat } from 'lodash'

import getStore from '../store'

import { Select } from 'antd'
const { Option } = Select



// Some comboboxes have no "key", but an "id" field as key.
const specialCombos = {
	plants: {
		key: 'id',
		value: 'name'
	},
	actions: {
		key: 'id',
		value: 'name'
	}
}


/**
 * Get the Select options for the given combobox name.
 * Adds the current value if deleted.
 * @param {String} name 
 * @param {String} key the currently selected option, or array of options
 * @param {Array} items the specific items to show. Other items will be hidden.
 */
export function getSelectOptions(name, keys, items) {
	const comboboxes = getStore().getState().comboboxes
	const keyName = specialCombos[name] ? specialCombos[name].key : 'key'
	const valueName = specialCombos[name] ? specialCombos[name].value : 'value'

	const getOptionElement = (option) => {
		if (name === 'actions') {
			return <Option key={option[keyName]}>{option[valueName] + ' (' + comboboxes.byKey['action-categories'][option.category].value + ')'}</Option>
		} else {
			return <Option key={option[keyName]}>{option[valueName]}</Option>
		}
	}
	
	// Add base options from list
	const options = items ? [] : comboboxes.list[name].map((option) => getOptionElement(option))

	// Function to add an option into the options list
	const addOption = (key) => {
		if (key && !find(options, option => option[keyName] === key)) {
			const option = comboboxes.byKey[name][key];
			if (option) {
				options.push(getOptionElement(option))
			}
		}
	}

	// Add deleted options if necessary
	let toAdd = []
	if (isArray(keys)) {
		toAdd = concat(toAdd, keys)
	} else {
		toAdd.push(keys)
	}
	if (items) {
		toAdd = concat(toAdd, items)
	}
	each(toAdd, key => addOption(key))

	// Return sorted options list
	return sortBy(options, 'props.children')
}

/**
 * Get the items for the given combobox name.
 * Adds the current value if deleted.
 * @param {String} name 
 * @param {String} key the currently selected option, or array of items
 */
export function getItems(name, keys) {
	const comboboxes = getStore().getState().comboboxes
	const keyName = specialCombos[name] ? specialCombos[name].key : 'key'
	
	// Add base item from list
	const items = cloneDeep(comboboxes.list[name])

	// Function to add an item into the items list
	const addItem = (key) => {
		if (key && !find(comboboxes.list[name], item => item[keyName] === key)) {
			const item = cloneDeep(comboboxes.byKey[name][key]);
			if (item) {
				items.push(item)
			}
		}
	}

	// Add deleted items if necessary
	if (isArray(keys)) {
		each(keys, key => addItem(key))
	} else {
		addItem(keys)
	}

	// Return sorted items list
	return sortBy(items, 'props.children')
}

/**
 * Get the items for the given combobox name.
 * Adds the current value if deleted.
 * @param {String} name 
 * @param {String} keys the array of items to get
 */
export function getSpecificItems(name, keys) {
	const keyName = specialCombos[name] ? specialCombos[name].key : 'key'
	const items = getItems(name, keys)
	return filter(items, (item) => keys.indexOf(item[keyName]) !== -1)
}


/**
 * Get options for the given combobox
 * @param {String} name 
 */
export function getOptions(name) {
	const comboboxes = getStore().getState().comboboxes
	return comboboxes.list[name]
}



// WEBPACK FOOTER //
// ./src/services/selectService.js